import { useQuery } from "@apollo/client"
import { client } from "../graphql-saleor/client"
import { GET_ALL_MODEMS } from "../graphql-saleor/queries/getallModems"
import { SELECTED_CHANNEL_SLUG, MODEM_SLUGS } from "../utils/saleor-constants"

export const useAllModems = () => {
  const { data, error, loading, refetch } = useQuery(GET_ALL_MODEMS, {
    client: client,
    variables: {
      selectedChannel: SELECTED_CHANNEL_SLUG,
      modemSlugs: MODEM_SLUGS,
    },
  })
  return {
    modems: data?.products?.edges,
    error,
    loading,
    refetch,
  }
}
